import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { logout } from "./authReducer";
import type { SpecimenTrackingFilters } from "../pages/SpecimenTracking/utils";

// The tracking feed unmounts whenever the user opens a specimen timeline, so
// filters held in the page's own state are lost on the way back. Keep the last
// applied set here instead; the page re-seeds from it on mount.
//
// In-memory only — the store is not persisted, which matters because the search
// term can carry specimen QRs and other patient identifiers.
type SpecimenTrackingState = {
  filters: SpecimenTrackingFilters | null;
};

const initialState: SpecimenTrackingState = {
  filters: null,
};

const specimenTrackingSlice = createSlice({
  name: "specimenTracking",
  initialState,
  reducers: {
    setSpecimenTrackingFilters: (
      state,
      action: PayloadAction<SpecimenTrackingFilters>,
    ) => {
      state.filters = action.payload;
    },
    clearSpecimenTrackingFilters: () => initialState,
  },
  // A logout does not always tear the app down (shared workstations sign a
  // second user in without a reload), and these filters carry the previous
  // user's org and search term — which can be a specimen QR. Drop them with
  // the session rather than relying on every logout path to remember.
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setSpecimenTrackingFilters, clearSpecimenTrackingFilters } =
  specimenTrackingSlice.actions;

export default specimenTrackingSlice.reducer;
